import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import styled from 'styled-components';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import { useTranslation, Trans } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import Container from '@yoweb/ui/components/containers/Container';
import { media } from '@yoweb/ui/styles/utils';
import { Text } from '@yoweb/ui/components/typography';
import { Button, ButtonLink } from '@yoweb/ui/components/buttons';
import { Link } from '@yoweb/ui/components/Link';
import { YohanaLogo } from '@yoweb/ui/components/Icon/YohanaLogo';
import { PAGE_CHECKOUT_PLAN, API_LOGIN, PAGE_PRIVACY_POLICY, PAGE_TERMS_OF_SERVICE, API_SIGNUP, PAGE_CHECKOUT_REDIRECT } from '@store/constants/routes';
import { th } from '@yoweb/ui/styles/utils/theme';
import { QUERY_PARAM_LOCALE, QUERY_PARAM_REDIRECT_TO } from '@yoweb/utils/constants/queryParams';
import { MarketingLayout } from '@store/components/layouts/MarketingLayout';
import { CheckboxUI } from '@yoweb/ui/components/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PanasonicLandingPage = function PanasonicLandingPage() {
  var _objectSpread2;

  var _useTranslation = useTranslation('company-relationship'),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useRouter = useRouter(),
      query = _useRouter.query;

  var _useState = useState(true),
      acceptTermsOfService = _useState[0],
      setAcceptTermsOfService = _useState[1];

  var bgColor = 'sand';
  var registerLabel = t('cta-register');
  var loginLabel = t('cta-login');
  return /*#__PURE__*/_jsx(MarketingLayout, {
    bgColor: bgColor,
    hideHeader: true,
    children: /*#__PURE__*/_jsx(Box, {
      mt: {
        _: 'xl3',
        lg: 'xl4'
      },
      mb: {
        _: 'medium3',
        lg: 'xl3'
      },
      children: /*#__PURE__*/_jsx(Container, {
        withGrid: true,
        children: /*#__PURE__*/_jsxs(ContentAreaV2, {
          children: [/*#__PURE__*/_jsx(Box, {
            width: 151,
            height: 48,
            children: /*#__PURE__*/_jsx(YohanaLogo, {
              width: "100%",
              height: "100%"
            })
          }), /*#__PURE__*/_jsx(Box, {
            height: 302,
            width: 328,
            position: "relative",
            children: /*#__PURE__*/_jsx(Image, {
              src: "/images/introduction/customer-base.png",
              layout: "fill"
            })
          }), /*#__PURE__*/_jsx(Box, {
            mt: "normal1",
            children: /*#__PURE__*/_jsx(TextNewLines, {
              size: "md",
              textAlign: "center",
              children: t('main-text')
            })
          }), /*#__PURE__*/_jsx(Box, {
            mt: "normal1",
            children: /*#__PURE__*/_jsx(TermsCheckbox, {
              id: "termsOfService",
              name: "termsOfService",
              "data-testid": "termsOfService-input",
              onChange: function onChange() {
                return setAcceptTermsOfService(!acceptTermsOfService);
              },
              checked: acceptTermsOfService,
              children: /*#__PURE__*/_jsx(Text, {
                size: "md",
                children: /*#__PURE__*/_jsx(Trans, {
                  t: t,
                  i18nKey: "terms-of-service-checkbox",
                  components: [/*#__PURE__*/_jsx(ButtonLink, {
                    size: "md",
                    variant: "muted",
                    as: "a",
                    href: PAGE_TERMS_OF_SERVICE
                  }, 0)]
                })
              })
            })
          }), /*#__PURE__*/_jsx(Box, {
            mt: "small2",
            children: /*#__PURE__*/_jsx(TextNewLines, {
              size: "sm",
              maxWidth: 321,
              children: /*#__PURE__*/_jsx(Trans, {
                t: t,
                i18nKey: "terms-of-service",
                components: [/*#__PURE__*/_jsx(ButtonLink, {
                  size: "md",
                  variant: "muted",
                  as: "a",
                  href: PAGE_PRIVACY_POLICY
                }, 0)]
              })
            })
          }), acceptTermsOfService && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Box, {
              mt: "normal2",
              width: "100%",
              maxWidth: 392,
              children: /*#__PURE__*/_jsx(Link, {
                href: "".concat(API_SIGNUP, "?").concat(QUERY_PARAM_REDIRECT_TO, "=").concat(PAGE_CHECKOUT_REDIRECT, "&").concat(QUERY_PARAM_LOCALE, "=").concat(i18n.language),
                hasUnderline: true,
                "data-testid": "introduction-register-button-link",
                children: /*#__PURE__*/_jsx(Button, {
                  size: "lg",
                  isFullWidth: true,
                  "data-testid": "intro-register-button",
                  children: registerLabel
                })
              })
            }), /*#__PURE__*/_jsx(Box, {
              mt: "normal2",
              children: /*#__PURE__*/_jsx(Link, {
                href: {
                  pathname: API_LOGIN,
                  query: _objectSpread(_objectSpread({}, query), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, QUERY_PARAM_LOCALE, i18n.language), _defineProperty(_objectSpread2, QUERY_PARAM_REDIRECT_TO, PAGE_CHECKOUT_PLAN), _objectSpread2))
                },
                hasUnderline: true,
                "data-testid": "introduction-login-button",
                children: loginLabel
              })
            })]
          }), !acceptTermsOfService && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Box, {
              mt: "normal2",
              width: "100%",
              maxWidth: 392,
              children: /*#__PURE__*/_jsx(Button, {
                size: "lg",
                isFullWidth: true,
                disabled: true,
                "data-testid": "intro-register-button",
                children: registerLabel
              })
            }), /*#__PURE__*/_jsx(Box, {
              mt: "normal2",
              children: /*#__PURE__*/_jsx(DisabledText, {
                children: loginLabel
              })
            })]
          })]
        })
      })
    })
  });
};

var TextNewLines = styled(Text).withConfig({
  componentId: "sc-o90gsz-0"
})(["&&{white-space:pre-line;}"]);
var ContentAreaV2 = styled.div.withConfig({
  componentId: "sc-o90gsz-1"
})(["display:grid;justify-items:center;grid-column:1/-1;border-radius:", ";", " ", " ", ""], th.getRadii('large'), media.sm(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    grid-column: 2/-2;\n    padding: unset;\n  "])), th.getColor('sand')), media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    grid-column: 2/-2;\n    padding: ", ";\n  "])), th.getColor('base000'), th.getSpace('medium1')), media.lg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    grid-column: 4/-4;\n    padding: ", "  ", "  ", ";\n  "])), th.getColor('base000'), th.getSpace('medium2'), th.getSpace('medium2'), th.getSpace('medium1')));
var DisabledText = styled(Text).withConfig({
  componentId: "sc-o90gsz-2"
})(["text-decoration:underline;color:", ";"], th.getColor('base400'));
var TermsCheckbox = styled(CheckboxUI).withConfig({
  componentId: "sc-o90gsz-3"
})(["&&{span{font-size:'14px';}}"]);
export var __N_SSP = true;
export default _withSuperJSONPage(PanasonicLandingPage);